import { type Observable, of } from "rxjs";
import { map } from "rxjs/operators";

import { type MetricField } from "../../../gql-generated/types";
import { type GetOrganicStatsQuery } from "../../api/queries";
import { isEmptyStateAgeStats } from "../../math";
import { type CountriesStatsItem, type InsightsMetrics, type OsStatsItem, countryDimensions } from "../../models";
import { computeAgeGenderStats } from "../computeAgeGenderStats";

import { mapAudienceMetrics } from "./mapAudienceMetrics";
import { sortAndMapAudienceStats } from "./sortAndMapAudienceStats";

export const mapAudienceStats = (
    data: GetOrganicStatsQuery,
    baseMetricField: MetricField,
): Observable<{
    ageGenderMetrics: ReturnType<typeof computeAgeGenderStats> | { isEmpty?: boolean };
    osMetrics: InsightsMetrics<OsStatsItem>;
    countryMetrics: InsightsMetrics<CountriesStatsItem>;
    interestMetrics: InsightsMetrics<CountriesStatsItem>;
}> =>
    of(data).pipe(
        map((data) => mapAudienceMetrics(data.getMyLensesOrganicStats.responseEntryList, baseMetricField)),
        map((metrics) => sortAndMapAudienceStats({ ...metrics, dimensionsFields: countryDimensions })),
        map(({ countryMetrics, interestMetrics, ageGenderStats, osMetrics }) => {
            const ageGenderMetrics = isEmptyStateAgeStats(ageGenderStats)
                ? { isEmpty: true }
                : computeAgeGenderStats(ageGenderStats);

            return {
                ageGenderMetrics,
                osMetrics,
                countryMetrics,
                interestMetrics,
            };
        }),
    );
